import React from 'react';
import styles from './MaintenanceOverlay.module.css';

/**
 * Bakım modu ekranı. Sadece bilgilendirme; form/buton yok.
 */
const MaintenanceOverlay = ({ message = '' }) => {
  return (
    <div className={styles.overlay} role="status" aria-live="polite">
      <div className={styles.card}>
        <div className={styles.icon}>🔧</div>
        <h1 className={styles.title}>Bakımdadır</h1>
        <p className={styles.subtitle}>Yakında tekrar hizmetinizdeyiz.</p>
        {message && <p className={styles.message}>{message}</p>}
      </div>
    </div>
  );
};

export default MaintenanceOverlay;
